import React, { Component } from "react"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import Login from "./routes/login"
import Panel from "./routes/panel"
import Bot from "./routes/bot"
import Page from "./routes/page"
import "./App.css"

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path={"/orders"} component={Panel} />
          <Route exact path={"/bot"} component={Bot} />
          <Route exact path={"/panel"} component={Page} />
          <Route path={"/"} component={Login} />
        </Switch>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js